// NPM Imports
import React, { useState } from "react";
import { connect } from "react-redux";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Label, Input, Toastr } from "../../revvComponents";

// Components Imports

// Actions Imports
import { updateDocMeta } from "../../actions/DocumentActions";
import { updateTemplateMeta } from "../../actions/DocumentTemplateActions/templateActions";

// SERVICE Imports

// Internal Imports

// Destructuring

// Declarations
const FORM_FIELD_DISPLAY_TYPE = {
  NONE: "NONE",
  BLANK_WITH_EMPTY: "BLANK_WITH_EMPTY",
};

const FormFieldsSetting = props => {
  const allowEdit =
    props.mode === "TEMPLATE" ||
    (props.mode === "DOCUMENT" && props.docStage === "DRAFT");
  const [formFieldDisplayType, updateFormFieldDisplaySetting] = useState(
    (props.metaData && props.metaData.formFieldsSettingsType) ||
      FORM_FIELD_DISPLAY_TYPE.NONE,
  );
  const _updateFormFieldDisplaySetting = type => {
    if (allowEdit) {
      const data = [
        {
          op: "replace",
          field: "meta_data",
          value: {
            meta_data: {
              ...props.metaData,
              formFieldsSettingsType: type,
            },
          },
        },
      ];
      if (props.mode === "DOCUMENT") {
        props
          .updateDocMeta({ docId: props.docID, data })
          .then()
          .catch(() => {
            Toastr.showToastr({
              type: "failure",
              message: "Oops, Something went wrong!!",
              timeout: 3000,
            });
          });
      }
      if (props.mode === "TEMPLATE") {
        props
          .updateTemplateMeta({ docId: props.docID, data })
          .then()
          .catch(() => {
            Toastr.showToastr({
              type: "failure",
              message: "Oops, Something went wrong!!",
              timeout: 3000,
            });
          });
      }
      updateFormFieldDisplaySetting(type);
    }
  };
  return (
    <div className={`formfieldsetting-wrapper ${props.className}`}>
      {props.showHeading && (
        <div className="formfieldsetting-info-wrapper">
          <div className="formfieldsetting-info-title">
            [ ] Field display settings
          </div>
          <div className="formfieldsetting-info-sub-title">
            Decide what you want to do with empty fields when document is shared
            or downloaded
          </div>
        </div>
      )}
      <div className="formfieldsetting-form-wrapper">
        <div>
          <Label
            htmlfor="fieldDispalySetting"
            className="formfieldsetting-form-label">
            <Input
              type="radio"
              className={!allowEdit ? "revvInput_isDisabled" : ""}
              name="fieldDispalySetting"
              checked={formFieldDisplayType === FORM_FIELD_DISPLAY_TYPE.NONE}
              onChange={() =>
                _updateFormFieldDisplaySetting(FORM_FIELD_DISPLAY_TYPE.NONE)
              }
              data-test="createTemplate-radio"
            />
            Leave as is
          </Label>
        </div>
        <div>
          <Label
            htmlfor="fieldDispalySetting"
            className="formfieldsetting-form-label">
            <Input
              type="radio"
              name="fieldDispalySetting"
              className={!allowEdit ? "revvInput_isDisabled" : ""}
              checked={
                formFieldDisplayType ===
                FORM_FIELD_DISPLAY_TYPE.BLANK_WITH_EMPTY
              }
              onChange={() =>
                _updateFormFieldDisplaySetting(
                  FORM_FIELD_DISPLAY_TYPE.BLANK_WITH_EMPTY,
                )
              }
              data-test="createTemplate-radio"
            />
            Replace empty fields with blank
          </Label>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state, ownProps) => {
  const {
    document: { id: docID, meta_data: docMetaData, stage: docStage },
  } = state.DocumentStore;

  let metaData;

  if (ownProps.mode === "DOCUMENT") {
    metaData = docMetaData;
  }
  if (ownProps.mode === "TEMPLATE") {
    const { template: { meta_data: templateMetaData } = {} } =
      state.TemplateStore;
    metaData = templateMetaData;
  }

  return {
    metaData,
    docStage,
    docID,
  };
};

const mapDispatchToProps = {
  updateTemplateMeta,
  updateDocMeta,
};

export default connect(mapStateToProps, mapDispatchToProps)(FormFieldsSetting);
